import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

const _defaultValue = '-';

export default (path = undefined, map, defaultValue = _defaultValue) => {

  return (value) => {
    if (value === 'N/A' || isNil(value)) {
      return defaultValue;
    }

    if (path) {
      if (isEmpty(value)) {
        return defaultValue;
      }
      return get(value, path, defaultValue);
    }

    return map?.(value) || value;
  };
};
